export const techStackMainTheme = {
  name: "main",
  profileText: "white",
  text: "white",
  background:
    "radial-gradient(circle at 70% 70%, rgba(249, 168, 39, 0.84), transparent 40%), radial-gradient(circle at 70% 20%, rgba(247, 81, 159, 1), transparent 50%), radial-gradient(circle at 70% 70%, rgba(255, 86, 128, 0.96), transparent 80%),  #fab3bbff",
  navBackground: "#f8f8f852",
  sideBarText: "white",
  contactBackground: "transparent",
  pcodeColor: "white",
  footerBackground:
    "linear-gradient(135deg,rgba(250, 174, 206, 0.53) 0%,rgba(101, 71, 119, 0.32) 100%)",
};

export const intro = {
  name: "intro",
  profileText: "white",
  text: "white",
  background: "red",
  navBackground: "rgb(255 255 255 / 20%);",
  sideBarText: "white",
  contactBackground: "transparent",
  pcodeColor: "white",
  footerBackground:
    "linear-gradient(135deg,rgba(196, 174, 250, 0.95) 0%,rgba(101, 71, 119, 0.95) 100%)",
};

export const experience = {
  name: "experience",
  profileText: "#123693",
  text: "#123693",
  background: "#f1f5fe",
  navBackground: "#e6e4ff",
  sideBarText: "#123693",
  contactBackground: "#b5b1dc",
  hoverListItemBackground: "#d5ffed",
  pcodeColor: "#123693",
  titleColor: "#38384f",
  footerBackground:
    "linear-gradient(135deg,rgba(195, 174, 250, 0.46) 0%,rgba(14, 11, 101, 0.58) 100%)",
};

export const education = {
  name: "experience",
  profileText: "black",
  text: "black",
  background: "#f1f5fe",
  navBackground: "#ffc864",
  sideBarText: "black",
  contactBackground: "#ffc864",
  hoverListItemBackground: "#ffeacc",
  pcodeColor: "white",
  titleColor: "#432a30ff",
  footerBackground:
    "linear-gradient(135deg, rgba(225, 195, 132, 0.95) 0%, rgba(243, 186, 132, 0.95) 100% 100%)",
};

export const techStackSubPageTheme = {
  name: "experience",
  profileText: "#123693",
  text: "#123693",
  background: "#ffffffff",
  navBackground: "#e6e4ff",
  sideBarText: "#123693",
  contactBackground: "#b5b1dc",
  hoverListItemBackground: "#d5ffed",
  pcodeColor: "#123693",
  titleColor: "#38384f",
  footerBackground:
    "linear-gradient(135deg,rgba(196, 174, 250, 0.95) 0%,rgba(101, 71, 119, 0.95) 100%)",
};
